import {
  TeamsReportAnalysisMode,
  TeamsReportSection,
  TeamsReportStat,
  TeamsReportStatus,
} from '../../api/reports/teamsReports';

export const SNAPSHOT_STATS: { value: TeamsReportStat; label: string }[] = [
  { value: 'headcount', label: 'Headcount' },
  { value: 'workforce_by_role', label: 'Workforce by role / trade' },
  { value: 'nationalities', label: 'Nationalities' },
  { value: 'gender_split', label: 'Gender split' },
  { value: 'rtw_status', label: 'Right to Work status' },
  { value: 'id_verification', label: 'ID verification status' },
  { value: 'qualifications_coverage', label: 'Qualifications coverage' },
  { value: 'team_proximity', label: 'Team proximity' },
];

export interface SectionOption {
  value: TeamsReportSection;
  label: string;
  hint: string;
  /** Personal data or documents: shown in amber, and logged when it leaves the platform. */
  sensitive?: boolean;
}

export const INDIVIDUAL_SECTIONS: SectionOption[] = [
  {
    value: 'qualifications',
    label: 'Qualifications & cards',
    hint: 'Names, issuing body, status, expiry, reference numbers, card images.',
  },
  {
    value: 'professional',
    label: 'Professional information',
    hint: 'Job title, team, work history.',
  },
  {
    value: 'personal',
    label: 'Personal information',
    hint: 'Email, mobile, date of birth, address.',
    sensitive: true,
  },
  {
    value: 'id_rtw',
    label: 'ID & Right to Work',
    hint: 'Status, expiry, document type and images, Home Office online check.',
    sensitive: true,
  },
];

export type SectionPresetKey = 'qualifications' | 'personal' | 'everything';

export const SECTION_PRESETS: { key: SectionPresetKey; label: string; sections: TeamsReportSection[] }[] = [
  { key: 'qualifications', label: 'Just qualifications', sections: ['qualifications'] },
  { key: 'personal', label: 'Personal information', sections: ['professional', 'personal'] },
  {
    key: 'everything',
    label: 'Everything we hold',
    sections: ['professional', 'qualifications', 'id_rtw', 'personal'],
  },
];

export const REPORT_TYPE_LABELS = {
  company_snapshot: 'Company snapshot',
  individual: 'Individual report',
} as const;

export const ANALYSIS_LABELS: Record<TeamsReportAnalysisMode, string> = {
  none: 'No analysis',
  preset: 'Building Safety Regulations compliance',
  custom: 'Custom request',
};

export const STATUS_LABELS: Record<TeamsReportStatus, string> = {
  pending: 'Queued',
  running: 'Generating…',
  completed: 'Ready',
  failed: 'Failed',
  expired: 'Expired',
};

export const ANALYSIS_REQUEST_MAX = 2000;
export const MAX_PEOPLE = 50;
export const MAX_RECIPIENTS = 20;

export const POLL_INTERVAL_MS = 5000;
/** Worst case is 15 minutes; after that we stop and point at the Reports page. */
export const POLL_TIMEOUT_MS = 15 * 60 * 1000;

export const REPORTS_PAGE_SIZE = 20;
export const REPORTS_ROUTE = '/teams/reports';
